import { delay } from 'redux-saga';
import { all, call, put, take, fork, select } from 'redux-saga/effects';
import {
  getCalendar,
} from '@xanadu/ui-shared/modules/events/actions';

import { PRODUCTS } from '../../constants';

import { CHANGE_PRODUCT, PAGE_VISIBILITY_CHANGE } from '@xanadu/ui-shared/modules/application/actions';

/**
 * This is the interval (ms) before the subscribed Horse Racing events can be refreshed
 * @type {Number}
 */
const HR_EVENTS_POLLING = 60000;

/**
 * TO REMOVE after refactoring of homepage/RaceCards component
 * Horse racing events polling task that runs every N seconds
 * @yield {undefined}
 */
function* pollHorseRacingCalendar() {
  yield take(CHANGE_PRODUCT);

  while (true) {
    const visible = yield select(state => state.getIn(['application', 'visible']));
    const product = yield select(state => state.getIn(['application', 'product']));

    const eligibleProducts = [PRODUCTS.exchange, PRODUCTS.mbzero].includes(product);

    if (visible && eligibleProducts) {
      yield put(getCalendar({ tags: ['horse-racing'] }, { loading: false, noThrottle: true }));
    } else {
      // eslint-disable-next-line no-console
      console.info('HR events queued');
      yield take(PAGE_VISIBILITY_CHANGE);

      yield put(getCalendar({ tags: ['horse-racing'] }, { loading: false, noThrottle: true }));
    }

    yield call(delay, HR_EVENTS_POLLING);
  }
}

export default function* root() {
  yield all([
    fork(pollHorseRacingCalendar),
  ]);
}
